// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"266":"a8dc6ef6","797":"43700597","824":"b90326e3","932":"6812a5f2","984":"5fe26f30"}[chunkId] + ".css";
};